<template>
  <div :class="[{ root: true,sidebarClose, sidebarStatic },theme_name]">
    <Sidebar />
    <!-- <Helper/> -->
    <div class="wrap">
      <Header />
      <v-touch class="content" @swipe="handleSwipe" :swipe-options="{direction: 'horizontal'}">
        <loading
          :active.sync="isLoading"
          :is-full-page="false"
          loader="Dots"
          :height="30"
          :width="45"
        ></loading>

        <transition name="router-animation">
          <router-view />
        </transition>
        <footer class="contentFooter">
          <!-- Invoice -->
        </footer>
      </v-touch>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { mapState, mapActions, mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notification";
import Sidebar from "@/components/Sidebar/Sidebar";
import Header from "@/components/Header/Header";
import Loading from "vue-loading-overlay";

import "./Layout.scss";
export default {
  mixins: [notificationMixin],
  name: "Layout",
  components: {
    Sidebar,
    Header,
    Loading

    // Helper
  },
  data() {
    return {
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center"
    };
  },
  methods: {
    ...mapActions("layout", [
      "switchSidebar",
      "handleSwipe",
      "changeSidebarActive",
      "toggleSidebar"
    ]),
    handleWindowResize() {
      const width = window.innerWidth;
      if (width <= 768 && this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      }
    }
  },
  created() {
    $("html").addClass(this.theme_name);
    // to get the messenger notification in pretty format
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    this.$store.state.layout.sidebarStatic = true;
    if (this.$AppDetails) {
      this.orgCurrency = this.getDetails(
        this.$AppDetails.currency_details,
        this.$AppDetails.organization.org_currency,
        "currency_code"
      );
      this.orgCurrencySymbol = this.getDetails(
        this.$AppDetails.currency_details,
        this.$AppDetails.organization.org_currency,
        "currency_symbol"
      );
    }
    this.handleWindowResize();
    window.addEventListener("resize", this.handleWindowResize);
  },
  computed: {
    isLoading: {
      get() {
        return this.$store.state.layout.isLoading;
      },
      set(value) {
        this.$store.state.layout.isLoading = value;
      }
    },
    orgCurrency: {
      get() {
        return this.$store.state.permission.orgCurrency;
      },
      set(value) {
        this.$store.state.permission.orgCurrency = value;
      }
    },
    orgCurrencySymbol: {
      get() {
        return this.$store.state.permission.orgCurrencySymbol;
      },
      set(value) {
        this.$store.state.permission.orgCurrencySymbol = value;
      }
    },
    ...mapState("layout", {
      sidebarClose: state => state.sidebarClose,
      sidebarStatic: state => state.sidebarStatic
    }),
    ...mapGetters(["theme_name"])
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>
<style src="./Layout.scss" lang="scss" />